import React from 'react';

const TravelComfortUI = () => {
  return (
    <div className="min-h-screen bg-white p-8 md:p-16">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 gap-8">
          <div className="flex-1">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-gray-900 leading-tight">
              Effortless Travel Starts<br />with <span className="text-red-600 font-semibold"style={{ color: 'rgba(65, 1, 150, 1)' }}>Comfort Services</span>
            </h1>
          </div>
          <div className="flex-1 lg:max-w-xl">
            <p className="text-gray-700 text-lg leading-relaxed">
              <span className="text-red-600 font-semibold" style={{ color: 'rgba(65, 1, 150, 1)' }}>Shree Puja
TRAVELS</span> provides premium services tailored for a hassle-free travel experience. With top-tier amenities, easy booking, and unmatched comfort, we guarantee smooth and relaxing journeys.
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Fast Booking */}
          <div className="border-4 border-gray-900 rounded-3xl p-8 bg-white relative" >
            <div className="mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-100 to-pink-50 rounded-2xl flex items-center justify-center relative">
                <div className="absolute -top-2 -left-2 w-3 h-3 bg-yellow-400 rounded-full"></div>
                <div className="absolute -top-1 -right-2 w-2 h-2 bg-orange-400 rounded-full"></div>
                <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-pink-400 rounded-full"></div>
                <svg className="w-12 h-12 text-purple-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <rect x="5" y="2" width="14" height="20" rx="2" strokeWidth="2"/>
                  <path d="M12 18h.01" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="15" cy="10" r="3" fill="currentColor" stroke="none"/>
                  <path d="M13 10l1.5 1.5 3-3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-3">Fast Booking</h3>
            <p className="text-gray-600 leading-relaxed">
              Instant Cab booking in just a few simple clicks.
            </p>
          </div>

          {/* Stress Free */}
          <div className="border-4 border-gray-900 rounded-3xl p-8 bg-white">
            <div className="mb-6">
              <div className="w-20 h-20 flex items-center justify-center">
                <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='35' r='12' fill='%23D4A574'/%3E%3Cpath d='M50 47c-8 0-15 5-15 12v25c0 3 2 5 5 5h20c3 0 5-2 5-5V59c0-7-7-12-15-12z' fill='%238B6F47'/%3E%3Cpath d='M35 70h30v14H35z' fill='%23D4A574'/%3E%3Ccircle cx='42' cy='77' r='2' fill='%23333'/%3E%3Ccircle cx='58' cy='77' r='2' fill='%23333'/%3E%3Cpath d='M30 60c-3-2-5-3-7-2-3 2-2 8 0 12 1 2 3 3 5 2l2-12z' fill='%23D4A574'/%3E%3Cpath d='M20 75l-8 8c-2 2-2 5 0 7s5 2 7 0l8-8-7-7z' fill='%23C9A55B'/%3E%3Ccircle cx='75' cy='30' r='15' fill='%23F4E4C1' opacity='0.7'/%3E%3Cpath d='M85 55c-5-3-10-2-12 2l-8 15 10 5 8-15c2-4 7-4 2-7z' fill='%23C9A55B'/%3E%3C/svg%3E" alt="Traveler" className="w-full h-full object-contain" />
              </div>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-3">Stress Free</h3>
            <p className="text-gray-600 leading-relaxed">
              On time, comfortable, and truly stress-free Cab journeys.
            </p>
          </div>

          {/* Save More */}
          <div className="border-4 border-gray-900 rounded-3xl p-8 bg-white">
            <div className="mb-6">
              <div className="w-20 h-20 flex items-center justify-center">
                <svg viewBox="0 0 100 100" className="w-full h-full">
                  <g transform="rotate(-10 50 50)">
                    {[0, 1, 2, 3, 4].map((i) => (
                      <ellipse
                        key={i}
                        cx="50"
                        cy={55 - i * 3}
                        rx="25"
                        ry="8"
                        fill="#2DD4BF"
                        opacity={0.8 - i * 0.1}
                      />
                    ))}
                    <ellipse cx="70" cy="40" rx="20" ry="25" fill="#EF4444" opacity="0.9"/>
                    <path d="M 70 25 Q 75 20 70 15 Q 65 20 70 25" fill="#DC2626"/>
                  </g>
                </svg>
              </div>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-3">Save More</h3>
            <p className="text-gray-600 leading-relaxed">
              Save more on every ride with easy Cab booking.
            </p>
          </div>

          {/* Live Tracking */}
          <div className="border-4 border-gray-900 rounded-3xl p-8 bg-white">
            <div className="mb-6">
              <div className="w-20 h-20 flex items-center justify-center">
                <svg viewBox="0 0 100 100" className="w-full h-full">
                  <defs>
                    <linearGradient id="mapGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#3B82F6" />
                      <stop offset="100%" stopColor="#1D4ED8" />
                    </linearGradient>
                  </defs>
                  <rect x="10" y="25" width="80" height="60" rx="8" fill="url(#mapGrad)"/>
                  <path d="M 20 40 L 35 50 L 45 35 L 60 55 L 75 45 L 85 50" 
                        stroke="#60A5FA" strokeWidth="2" fill="none" opacity="0.5"/>
                  <path d="M 25 45 L 40 35 L 55 50 L 70 40" 
                        stroke="#93C5FD" strokeWidth="1.5" fill="none" opacity="0.4"/>
                  <circle cx="50" cy="45" r="12" fill="#EF4444"/>
                  <circle cx="50" cy="45" r="8" fill="#DC2626"/>
                  <path d="M 50 37 L 50 45 L 50 53" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  <circle cx="50" cy="45" r="20" fill="none" stroke="#EF4444" strokeWidth="2" opacity="0.3">
                    <animate attributeName="r" from="12" to="25" dur="2s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" from="0.5" to="0" dur="2s" repeatCount="indefinite"/>
                  </circle>
                </svg>
              </div>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-3">Live Tracking</h3>
            <p className="text-gray-600 leading-relaxed">
              Real time tracking for a worry-free travel experience.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelComfortUI;